import { useEffect, useRef } from 'react';

// todo this is still not good - because we're missing convenient way to calculate derived state from multiple
//  contexts. Redux solved this with `reselect`, but it didn't have to deal with multiple stores. We should come up
//  with something similar, or even switch to some more modern state management library.
/**
 * Run effect once ASAP when it isReady()
 * @param {Function} cb
 * @param {Array} [deps]
 * @param {Function} [isReady] - predicate to indicate when we are ready to run the effect
 */
export const useEffectOnce = (cb, deps, isReady = () => true) => {
    const didRun = useRef(false);
    const result = useRef();

    useEffect(() => {
        if (!didRun.current && isReady()) {
            didRun.current = true;
            result.current = cb();
        }

        return result.current;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
